<div class="checkout-page">

  <div class="checkout-loading-state" *ngIf="isLoading; else checkoutContent">
    <nz-spin [nzSpinning]="true"></nz-spin>
  </div>

  <ng-template #checkoutContent>
    <ng-container *ngIf="draftUnavailable || draftLoadError; else catalogContent">
      <nz-card class="draft-unavailable-card">
        <nz-alert
          nzType="warning"
          [nzMessage]="draftLoadError || ('SIGN_ORDER.DRAFTS.UNAVAILABLE' | translate)"
          nzShowIcon
        ></nz-alert>
        <div class="draft-unavailable-card__actions">
          <button nz-button nzType="default" type="button" (click)="navigateOrders.emit()">
            {{ 'SIGN_ORDER.DRAFTS.BACK_TO_ORDERS' | translate }}
          </button>
          <button *ngIf="loadedDraft" nz-button nzDanger type="button" (click)="confirmDeleteDraft()" [nzLoading]="draftDeleting">
            {{ 'SIGN_ORDER.DRAFTS.DELETE' | translate }}
          </button>
        </div>
      </nz-card>
    </ng-container>

    <ng-template #catalogContent>
    <ng-container *ngIf="catalog; else catalogLoadError">
      <ng-container *ngIf="!catalog.available; else availableCheckout">
        <nz-alert nzType="info" [nzMessage]="'SIGN_ORDER.CHECKOUT.UNAVAILABLE' | translate" nzShowIcon></nz-alert>
      </ng-container>

      <ng-template #availableCheckout>
        <nz-alert *ngIf="errorMessage" nzType="error" [nzMessage]="errorMessage" nzShowIcon class="error-alert"></nz-alert>

        <nz-steps [nzCurrent]="currentStep" nzSize="small" (nzIndexChange)="onStepHeaderIndexChange($event)" (keydown)="onStepHeaderKeydown($event)">
          <nz-step [nzTitle]="'SIGN_ORDER.CHECKOUT.STEP_PRODUCT' | translate" [nzDisabled]="isStepHeaderDisabled(STEP_PRODUCT)"></nz-step>
          <nz-step [nzTitle]="'SIGN_ORDER.CHECKOUT.STEP_PROPERTIES' | translate" [nzDisabled]="isStepHeaderDisabled(STEP_PROPERTIES)"></nz-step>
          <nz-step [nzTitle]="'SIGN_ORDER.CHECKOUT.STEP_DRILLING' | translate" [nzDisabled]="isStepHeaderDisabled(STEP_DRILLING)"></nz-step>
          <nz-step [nzTitle]="'SIGN_ORDER.CHECKOUT.STEP_SHIPPING' | translate" [nzDisabled]="isStepHeaderDisabled(STEP_SHIPPING)"></nz-step>
          <nz-step [nzTitle]="'SIGN_ORDER.CHECKOUT.STEP_REVIEW' | translate" [nzDisabled]="isStepHeaderDisabled(STEP_REVIEW)"></nz-step>
        </nz-steps>

        <div class="draft-status" *ngIf="shouldShowDraftActions || reconciliationNoticeKeys.length || draftSaveError">
          <div class="draft-status__saved" *ngIf="loadedDraft">
            <span>{{ 'SIGN_ORDER.DRAFTS.SAVED_STATE' | translate }}</span>
            <button nz-button nzType="link" nzDanger type="button" (click)="confirmDeleteDraft()" [nzLoading]="draftDeleting">
              {{ 'SIGN_ORDER.DRAFTS.DELETE' | translate }}
            </button>
          </div>
          <nz-alert *ngIf="draftSaveError" nzType="error" [nzMessage]="draftSaveError" nzShowIcon></nz-alert>
          <nz-alert *ngFor="let noticeKey of reconciliationNoticeKeys" nzType="info" [nzMessage]="noticeKey | translate" nzShowIcon></nz-alert>
        </div>

        <ng-container [ngSwitch]="currentStep">
          <ng-container *ngSwitchCase="STEP_PRODUCT">
            <ng-container *ngTemplateOutlet="productStep"></ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="STEP_PROPERTIES">
            <ng-container *ngTemplateOutlet="propertiesStep"></ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="STEP_DRILLING">
            <ng-container *ngTemplateOutlet="drillingStep"></ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="STEP_SHIPPING">
            <ng-container *ngTemplateOutlet="shippingStep"></ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="STEP_REVIEW">
            <ng-container *ngTemplateOutlet="reviewStep"></ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="STEP_CONFIRMATION">
            <ng-container *ngTemplateOutlet="confirmationStep"></ng-container>
          </ng-container>
        </ng-container>
      </ng-template>
    </ng-container>
    </ng-template>

    <ng-template #catalogLoadError>
      <nz-alert
        nzType="error"
        [nzMessage]="errorMessage || ('SIGN_ORDER.CHECKOUT.ERROR_LOADING' | translate)"
        nzShowIcon
        class="error-alert"
      ></nz-alert>
    </ng-template>
  </ng-template>
</div>

<ng-template #draftSaveConfirmation>
  <ng-template #draftSaveConfirmationActions>
    <div class="draft-save-confirmation__actions">
      <button nz-button nzType="default" nzSize="small" type="button" (click)="viewSavedDrafts()">
        {{ 'SIGN_ORDER.DRAFTS.VIEW_DRAFTS' | translate }}
      </button>
      <button nz-button nzType="default" nzSize="small" type="button" (click)="dismissDraftSaveConfirmation()">
        {{ 'SIGN_ORDER.DRAFTS.CONTINUE_EDITING' | translate }}
      </button>
    </div>
  </ng-template>

  <nz-alert
    *ngIf="draftSaveConfirmationVisible"
    class="draft-save-confirmation"
    nzType="success"
    [nzMessage]="'SIGN_ORDER.DRAFTS.SAVE_CONFIRMATION_TITLE' | translate"
    [nzDescription]="'SIGN_ORDER.DRAFTS.SAVE_CONFIRMATION_DESCRIPTION' | translate"
    [nzAction]="draftSaveConfirmationActions"
    nzShowIcon
    nzClosable
    (nzOnClose)="dismissDraftSaveConfirmation()"
  ></nz-alert>
</ng-template>

<ng-template #productStep>
  <div class="step-content" *ngIf="product">
    <nz-card class="product-card">
      <div class="product-gallery" *ngIf="product.images?.length">
        <div class="gallery-main">
          <button class="gallery-arrow gallery-prev" *ngIf="product.images.length > 1" (click)="galleryActiveIndex = galleryActiveIndex === 0 ? product.images.length - 1 : galleryActiveIndex - 1">
            <i nz-icon nzType="left" nzTheme="outline"></i>
          </button>
          <div class="gallery-image-frame">
            <ng-container *ngIf="product.images[galleryActiveIndex] as activeImage">
              <nz-spin [nzSpinning]="imageLoading[activeImage.url] || false" class="gallery-spinner">
                <ng-container *ngIf="getImageBlobUrl(activeImage.url) as activeImageBlobUrl">
                  <img
                    [src]="activeImageBlobUrl"
                    alt=""
                    aria-hidden="true"
                    class="gallery-backdrop"
                  />
                  <img
                    [src]="activeImageBlobUrl"
                    [alt]="localizedText(activeImage.alt)"
                    class="gallery-featured"
                  />
                </ng-container>
              </nz-spin>
            </ng-container>
          </div>
          <button class="gallery-arrow gallery-next" *ngIf="product.images.length > 1" (click)="galleryActiveIndex = galleryActiveIndex === product.images.length - 1 ? 0 : galleryActiveIndex + 1">
            <i nz-icon nzType="right" nzTheme="outline"></i>
          </button>
          <span class="gallery-caption-badge" *ngIf="product.images[galleryActiveIndex]?.caption?.de || product.images[galleryActiveIndex]?.caption?.en">
            {{ localizedText(product.images[galleryActiveIndex].caption) }}
          </span>
          <div class="gallery-counter" *ngIf="product.images.length > 1">{{ galleryActiveIndex + 1 }} / {{ product.images.length }}</div>
        </div>
      </div>

      <div class="product-details-grid">
        <div class="product-intro">
          <h2 class="product-name">{{ localizedText(product.name) }}</h2>
          <div class="product-specs">
            <span class="spec-pill">
              <i nz-icon nzType="file"></i>
              {{ 'SIGN_ORDER.CHECKOUT.FORMAT_' + product.format.toUpperCase() | translate }}
            </span>
            <span class="spec-pill">
              <i nz-icon nzType="appstore"></i>
              {{ 'SIGN_ORDER.CHECKOUT.MATERIAL_' + product.material.toUpperCase() | translate }}
            </span>
          </div>
          <p class="product-desc">{{ localizedText(product.description) }}</p>
        </div>

        <div class="pricing-section" *ngIf="priceSummary as summary">
          <div class="price-summary">
            <div class="price-summary__content">
              <div class="price-summary-label">{{ 'SIGN_ORDER.CHECKOUT.BASE_UNIT_PRICE_NET' | translate }}</div>
              <div class="price-summary-value">
                <ng-container *ngIf="summary.isRange; else singlePrice">
                  {{ formatCents(summary.lowestUnitNetCents, product.currency) }}–{{ formatCents(summary.highestUnitNetCents, product.currency) }}
                </ng-container>
                <ng-template #singlePrice>{{ formatCents(summary.lowestUnitNetCents, product.currency) }}</ng-template>
              </div>
              <p class="price-summary-helper">{{ 'SIGN_ORDER.CHECKOUT.QUANTITY_PRICE_HELPER' | translate }}</p>
              <p class="price-summary-clarification">{{ 'SIGN_ORDER.CHECKOUT.FINAL_PRICE_AFTER_CONFIGURATION' | translate }}</p>
            </div>
          </div>

          <div class="price-tier-disclosure">
            <button
              nz-button
              nzType="link"
              type="button"
              class="price-tier-toggle"
              [attr.aria-expanded]="showPriceTiers"
              aria-controls="sign-order-price-tier-table"
              (click)="togglePriceTiers()"
            >
              {{ (showPriceTiers ? 'SIGN_ORDER.CHECKOUT.HIDE_PRICE_TIERS' : 'SIGN_ORDER.CHECKOUT.SHOW_PRICE_TIERS') | translate }}
            </button>

            <div class="price-tier-table-wrap" *ngIf="showPriceTiers">
              <table id="sign-order-price-tier-table" class="price-tier-table">
                <thead>
                  <tr>
                    <th scope="col">{{ 'SIGN_ORDER.CHECKOUT.TIER_QUANTITY' | translate }}</th>
                    <th scope="col">{{ 'SIGN_ORDER.CHECKOUT.BASE_UNIT_PRICE_NET' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let tier of groupedPresentationPricingTiers">
                    <td>{{ formatTierQuantityRange(tier) }}</td>
                    <td>{{ formatCents(tier.unitNetCents, product.currency) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="product-disclosure">
        <i nz-icon nzType="info-circle"></i>
        <p>{{ 'SIGN_ORDER.LEGAL.PRODUCT_DISCLOSURE' | translate }}</p>
      </div>
      <div class="legal-links product-legal-links" *ngIf="legalLinks.length">
        <a [href]="legalLinks[0]?.url" target="_blank" rel="noopener noreferrer" class="legal-link">{{ 'SIGN_ORDER.LEGAL.LINK_TERMS' | translate }}</a>
      </div>
    </nz-card>

    <div class="step-actions step-actions--forward">
      <button nz-button nzType="primary" (click)="goToStep(STEP_PROPERTIES)">
        {{ 'SIGN_ORDER.CHECKOUT.NEXT' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #propertiesStep>
  <div class="step-content">
    <nz-card>
      <h3>{{ 'SIGN_ORDER.CHECKOUT.SELECT_PROPERTIES' | translate }}</h3>

      <div class="selection-summary" *ngIf="cachedItemCount > 0">
        <nz-tag nzColor="blue">
          {{ 'SIGN_ORDER.CHECKOUT.PROPERTIES_SELECTED' | translate:{ count: cachedItemCount } }}
        </nz-tag>
        <nz-tag nzColor="green">
          {{ 'SIGN_ORDER.CHECKOUT.TOTAL_COPIES' | translate:{ count: cachedCopyCount } }}
        </nz-tag>
        <button nz-button nzType="default" nzSize="small" nzDanger (click)="clearSelection()">
          {{ 'SIGN_ORDER.CHECKOUT.CLEAR_SELECTION' | translate }}
        </button>
      </div>
      <div class="current-tier-summary" *ngIf="cachedCopyCount > 0 && currentPresentationTier">
        {{ currentBaseTierSummaryTranslationKey | translate:{
          quantity: cachedCopyCount,
          unitPrice: formatCents(currentPresentationTier.unitNetCents, product?.currency || '')
        } }}
      </div>
      <nz-alert
        *ngIf="totalQuantityExceedsMaximum"
        nzType="warning"
        [nzMessage]="'SIGN_ORDER.DRAFTS.RECONCILIATION_TOTAL_EXCEEDS_MAXIMUM' | translate"
        nzShowIcon
      ></nz-alert>
      <div class="bulk-copies-bar" *ngIf="cachedItemCount > 0">
        <span class="bulk-label">{{ 'SIGN_ORDER.CHECKOUT.BULK_COPIES' | translate }}</span>
        <nz-input-number [(ngModel)]="bulkCopiesCount" [nzMin]="minimumCopiesPerProperty" [nzMax]="maximumCopiesPerProperty" nzSize="small" style="width:80px"></nz-input-number>
        <button nz-button nzType="primary" nzSize="small" (click)="applyBulkCopies()">{{ 'SIGN_ORDER.CHECKOUT.APPLY' | translate }}</button>
        <button *ngIf="cachedItemCount > 0" nz-button nzType="default" nzSize="small" (click)="openCopyOverrideModal()">
          {{ 'SIGN_ORDER.CHECKOUT.CUSTOMIZE_COPIES' | translate }}
        </button>
      </div>

      <div class="select-all-info" *ngIf="selection.selectAllData">
        <nz-alert
          *ngIf="selection.selectAllData.search; else selectAllWithoutSearch"
          nzType="info"
          nzShowIcon
          [nzMessage]="'SIGN_ORDER.CHECKOUT.SELECT_ALL_INFO' | translate:{ total: selection.selectAllData.total, search: selection.selectAllData.search }"
        ></nz-alert>
        <ng-template #selectAllWithoutSearch>
          <nz-alert
            nzType="info"
            nzShowIcon
            [nzMessage]="'SIGN_ORDER.CHECKOUT.SELECT_ALL_INFO_ALL' | translate:{ total: selection.selectAllData.total }"
          ></nz-alert>
        </ng-template>
      </div>

      <div class="search-bar">
        <input nz-input
          [placeholder]="'SIGN_ORDER.CHECKOUT.SEARCH_PLACEHOLDER' | translate"
          [(ngModel)]="propertySearch"
          (ngModelChange)="onPropertySearchChange()"
          (focus)="onSearchFocus()"
          [disabled]="!!selection.selectAllData"
          class="search-input"
        />
        <button nz-button nzType="default"
          (click)="selectAllMatching()"
          [disabled]="!!selection.selectAllData || propertyTotal === 0"
          [nzLoading]="isLoading">
          {{ 'SIGN_ORDER.CHECKOUT.SELECT_ALL' | translate }}
        </button>
      </div>

      <nz-spin [nzSpinning]="isSearching">
        <div class="property-check-list" *ngIf="propertyResults.length">
          <label nz-checkbox
            *ngFor="let prop of propertyResults; trackBy: trackById"
            [nzChecked]="visibleSelectedPropertyIds.has(prop.id)"
            (nzCheckedChange)="toggleProperty(prop.id)"
            class="property-check-item"
          >
            <span class="property-address-text">{{ prop.address }}</span>
            <span class="property-copies-badge" *ngIf="visibleSelectedPropertyIds.has(prop.id)">
              {{ 'SIGN_ORDER.CHECKOUT.COPIES' | translate }}: {{ visiblePropertyCopies[prop.id] || 1 }}
            </span>
          </label>
        </div>
        <div class="empty-state" *ngIf="!propertyResults.length && propertySearch">
          <p>{{ 'SIGN_ORDER.CHECKOUT.NO_RESULTS' | translate }}</p>
        </div>
        <div class="empty-state" *ngIf="!propertyResults.length && !propertySearch">
          <p>{{ 'SIGN_ORDER.CHECKOUT.SEARCH_TO_BEGIN' | translate }}</p>
        </div>
      </nz-spin>

      <nz-pagination
        *ngIf="propertyTotal > propertyPageSize"
        [(nzPageIndex)]="propertyPage"
        [nzPageSize]="propertyPageSize"
        [nzTotal]="propertyTotal"
        (nzPageIndexChange)="searchProperties($event)"
        nzSize="small"
        class="pagination"
      ></nz-pagination>
    </nz-card>

    <div class="draft-save-action-area">
      <ng-container *ngTemplateOutlet="draftSaveConfirmation"></ng-container>
      <div class="step-actions step-actions--with-draft">
        <button nz-button nzType="default" type="button" (click)="saveDraft()" [disabled]="!canSaveDraft" [nzLoading]="draftSaving">
          {{ 'SIGN_ORDER.DRAFTS.SAVE' | translate }}
        </button>
        <div class="step-actions__navigation">
          <button nz-button nzType="default" (click)="goToStep(STEP_PRODUCT)">
            {{ 'SIGN_ORDER.CHECKOUT.BACK' | translate }}
          </button>
          <button nz-button nzType="primary" (click)="goToStep(STEP_DRILLING)" [disabled]="cachedItemCount === 0 || totalQuantityExceedsMaximum">
            {{ 'SIGN_ORDER.CHECKOUT.NEXT' | translate }}
          </button>
        </div>
      </div>
    </div>
    <p class="selection-notice">{{ 'SIGN_ORDER.LEGAL.SELECTION_NOTICE' | translate }}</p>

    <nz-modal
      [nzVisible]="copyOverrideModalVisible"
      [nzTitle]="'SIGN_ORDER.CHECKOUT.CUSTOMIZE_COPIES_TITLE' | translate"
      [nzFooter]="null"
      [nzWidth]="800"
      (nzOnCancel)="closeCopyOverrideModal()"
    >
      <ng-container *nzModalContent>
        <p class="copy-override-modal__description">
          {{ 'SIGN_ORDER.CHECKOUT.CUSTOMIZE_COPIES_DESCRIPTION' | translate }}
        </p>

        <input
          nz-input
          [(ngModel)]="copyOverrideSearch"
          (ngModelChange)="onCopyOverrideSearchChange()"
          [placeholder]="'SIGN_ORDER.CHECKOUT.CUSTOMIZE_COPIES_SEARCH_PLACEHOLDER' | translate"
          class="copy-override-modal__search"
        />

        <nz-spin [nzSpinning]="isCopyOverrideLoading">
          <nz-table [nzData]="copyOverrideResults" [nzShowPagination]="false" nzSize="small">
            <thead>
              <tr>
                <th>{{ 'SIGN_ORDER.CHECKOUT.PROPERTY_ADDRESS' | translate }}</th>
                <th style="width:150px">{{ 'SIGN_ORDER.CHECKOUT.COPIES' | translate }}</th>
                <th style="width:130px"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let prop of copyOverrideResults; trackBy: trackById">
                <td>
                  <span>{{ prop.address || ('SIGN_ORDER.CHECKOUT.ADDRESS_UNAVAILABLE' | translate) }}</span>
                </td>
                <td>
                  <nz-input-number
                    *ngIf="!prop.isExcluded"
                    [ngModel]="prop.copies"
                    (ngModelChange)="setPropertyCopies(prop.id, $event)"
                    [nzMin]="minimumCopiesPerProperty"
                    [nzMax]="maximumCopiesPerProperty"
                    nzSize="small"
                    style="width:100%"
                  ></nz-input-number>
                  <nz-tag *ngIf="prop.isExcluded">{{ 'SIGN_ORDER.CHECKOUT.EXCLUDED' | translate }}</nz-tag>
                </td>
                <td>
                  <button *ngIf="prop.hasCopyOverride && !prop.isExcluded" nz-button nzType="link" nzSize="small" (click)="resetCopyOverride(prop.id)">
                    {{ 'SIGN_ORDER.CHECKOUT.RESET_TO_DEFAULT' | translate }}
                  </button>
                  <button nz-button nzType="link" nzSize="small"
                    [nzDanger]="!prop.isExcluded"
                    (click)="toggleProperty(prop.id)">
                    <i nz-icon [nzType]="prop.isExcluded ? 'plus-circle' : 'close-circle'"></i>
                    {{ prop.isExcluded ? ('SIGN_ORDER.CHECKOUT.INCLUDE' | translate) : ('SIGN_ORDER.CHECKOUT.EXCLUDE' | translate) }}
                  </button>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </nz-spin>

        <nz-pagination
          *ngIf="copyOverrideTotal > copyOverridePageSize"
          [(nzPageIndex)]="copyOverridePage"
          [nzPageSize]="copyOverridePageSize"
          [nzTotal]="copyOverrideTotal"
          (nzPageIndexChange)="loadCopyOverrideProperties($event)"
          nzSize="small"
          class="pagination"
        ></nz-pagination>

        <div class="copy-override-modal__actions">
          <button nz-button nzType="primary" (click)="closeCopyOverrideModal()">
            {{ 'SIGN_ORDER.CHECKOUT.DONE' | translate }}
          </button>
        </div>
      </ng-container>
    </nz-modal>
  </div>
</ng-template>

<ng-template #drillingStep>
  <div class="step-content">
    <nz-card class="drilling-card">
      <div class="drilling-header">
        <i nz-icon nzType="tool" class="drilling-header-icon"></i>
        <div>
          <h3>{{ 'SIGN_ORDER.CHECKOUT.DRILLING_TITLE' | translate }}</h3>
          <p>{{ 'SIGN_ORDER.CHECKOUT.DRILLING_DESC' | translate }}</p>
        </div>
      </div>

      <div class="drilling-cards">
        <div class="drilling-choice-card"
          [class.selected]="drillingOption === 'without_drilling'"
          (click)="selectDrillingOption('without_drilling')">
          <div class="drilling-choice-radio">
            <i nz-icon [nzType]="drillingOption === 'without_drilling' ? 'check-circle' : 'border'"
              [class.icon-selected]="drillingOption === 'without_drilling'"></i>
          </div>
          <div class="drilling-choice-content">
            <div class="drilling-choice-label">{{ 'SIGN_ORDER.CHECKOUT.DRILLING_WITHOUT' | translate }}</div>
            <div class="drilling-choice-desc">{{ 'SIGN_ORDER.CHECKOUT.DRILLING_WITHOUT_DESC' | translate }}</div>
          </div>
          <div class="drilling-choice-price">
            <ng-container *ngIf="baseUnitPriceDisplay as baseUnitPrice; else withoutDrillingQuoteState">
              {{ 'SIGN_ORDER.CHECKOUT.DRILLING_WITHOUT_UNIT_PRICE' | translate:{ unitPrice: baseUnitPrice } }}
            </ng-container>
            <ng-template #withoutDrillingQuoteState>
              {{ (isQuoteLoading || (quoteIsStale && !quoteRefreshFailed) ? 'SIGN_ORDER.CHECKOUT.DRILLING_PRICE_LOADING' : 'SIGN_ORDER.CHECKOUT.DRILLING_PRICE_UNAVAILABLE') | translate }}
            </ng-template>
          </div>
        </div>

        <div class="drilling-choice-card"
          *ngIf="product?.allowedDrillingOptions?.includes('with_drilling')"
          [class.selected]="drillingOption === 'with_drilling'"
          (click)="selectDrillingOption('with_drilling')">
          <div class="drilling-choice-radio">
            <i nz-icon [nzType]="drillingOption === 'with_drilling' ? 'check-circle' : 'border'"
              [class.icon-selected]="drillingOption === 'with_drilling'"></i>
          </div>
          <div class="drilling-choice-content">
            <div class="drilling-choice-label">{{ 'SIGN_ORDER.CHECKOUT.DRILLING_WITH' | translate }}</div>
            <div class="drilling-choice-desc">{{ 'SIGN_ORDER.CHECKOUT.DRILLING_WITH_DESC' | translate }}</div>
          </div>
          <div class="drilling-choice-price">
            <ng-container *ngIf="drillingUnitPriceDisplay as drillingUnitPrice; else withDrillingQuoteState">
              {{ 'SIGN_ORDER.CHECKOUT.DRILLING_WITH_UNIT_PRICE' | translate:{ unitPrice: drillingUnitPrice } }}
            </ng-container>
            <ng-template #withDrillingQuoteState>
              {{ (isQuoteLoading || (quoteIsStale && !quoteRefreshFailed) ? 'SIGN_ORDER.CHECKOUT.DRILLING_PRICE_LOADING' : 'SIGN_ORDER.CHECKOUT.DRILLING_PRICE_UNAVAILABLE') | translate }}
            </ng-template>
          </div>
        </div>
      </div>
    </nz-card>

    <div class="draft-save-action-area">
      <ng-container *ngTemplateOutlet="draftSaveConfirmation"></ng-container>
      <div class="step-actions step-actions--with-draft">
        <button nz-button nzType="default" type="button" (click)="saveDraft()" [disabled]="!canSaveDraft" [nzLoading]="draftSaving">
          {{ 'SIGN_ORDER.DRAFTS.SAVE' | translate }}
        </button>
        <div class="step-actions__navigation">
          <button nz-button nzType="default" (click)="goToStep(STEP_PROPERTIES)">
            {{ 'SIGN_ORDER.CHECKOUT.BACK' | translate }}
          </button>
          <button nz-button nzType="primary" (click)="goToStep(STEP_SHIPPING)">
            {{ 'SIGN_ORDER.CHECKOUT.NEXT' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #shippingStep>
  <div class="step-content">
    <nz-card class="shipping-card">
      <div class="shipping-header">
        <i nz-icon nzType="environment" nzTheme="twotone" class="shipping-header-icon"></i>
        <div>
          <h3>{{ 'SIGN_ORDER.CHECKOUT.SHIPPING_TITLE' | translate }}</h3>
          <p class="shipping-subtitle">Deutschland</p>
        </div>
      </div>

      <form [formGroup]="shippingForm" class="shipping-form">
        <div class="shipping-section">
          <div class="shipping-section-title">
            <i nz-icon nzType="bank"></i>
            {{ 'SIGN_ORDER.CHECKOUT.ADDRESS_COMPANY_NAME' | translate }}
          </div>
          <div class="shipping-row">
            <nz-form-item>
              <nz-form-control [nzValidateStatus]="shippingForm.get('companyName')?.touched && shippingForm.get('companyName')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.REQUIRED' | translate">
                <input nz-input formControlName="companyName" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_COMPANY_NAME' | translate" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="shipping-section">
          <div class="shipping-section-title">
            <i nz-icon nzType="user"></i>
            {{ 'SIGN_ORDER.CHECKOUT.ADDRESS_CONTACT_NAME' | translate }}
          </div>
          <div class="shipping-row">
            <nz-form-item>
              <nz-form-control [nzValidateStatus]="shippingForm.get('contactName')?.touched && shippingForm.get('contactName')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.REQUIRED' | translate">
                <input nz-input formControlName="contactName" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_CONTACT_NAME' | translate" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="shipping-section">
          <div class="shipping-section-title">
            <i nz-icon nzType="home"></i>
            {{ 'SIGN_ORDER.CHECKOUT.ADDRESS_STREET' | translate }} & {{ 'SIGN_ORDER.CHECKOUT.ADDRESS_HOUSE_NUMBER' | translate }}
          </div>
          <div class="shipping-row street-row">
            <nz-form-item>
              <nz-form-control [nzValidateStatus]="shippingForm.get('street')?.touched && shippingForm.get('street')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.REQUIRED' | translate">
                <input nz-input formControlName="street" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_STREET' | translate" class="street-input" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-control [nzValidateStatus]="shippingForm.get('houseNumber')?.touched && shippingForm.get('houseNumber')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.REQUIRED' | translate">
                <input nz-input formControlName="houseNumber" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_HOUSE_NUMBER' | translate" class="number-input" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div class="shipping-row">
            <nz-form-item>
              <nz-form-control>
                <input nz-input formControlName="addressLine2" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_LINE2' | translate" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="shipping-section">
          <div class="shipping-section-title">
            <i nz-icon nzType="compass"></i>
            {{ 'SIGN_ORDER.CHECKOUT.ADDRESS_POSTAL_CODE' | translate }} & {{ 'SIGN_ORDER.CHECKOUT.ADDRESS_CITY' | translate }}
          </div>
          <div class="shipping-row street-row">
            <nz-form-item>
              <nz-form-control [nzValidateStatus]="shippingForm.get('postalCode')?.touched && shippingForm.get('postalCode')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.POSTAL_CODE_INVALID' | translate">
                <input nz-input formControlName="postalCode" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_POSTAL_CODE' | translate" class="number-input" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-control [nzValidateStatus]="shippingForm.get('city')?.touched && shippingForm.get('city')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.REQUIRED' | translate">
                <input nz-input formControlName="city" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_CITY' | translate" class="street-input" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="shipping-section">
          <div class="shipping-section-title">
            <i nz-icon nzType="mail"></i>
            {{ 'SIGN_ORDER.CHECKOUT.ADDRESS_EMAIL' | translate }} & {{ 'SIGN_ORDER.CHECKOUT.ADDRESS_PHONE' | translate }}
          </div>
          <div class="shipping-row">
            <nz-form-item>
              <nz-form-control [nzValidateStatus]="shippingForm.get('email')?.touched && shippingForm.get('email')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.EMAIL_INVALID' | translate">
                <input nz-input formControlName="email" type="email" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_EMAIL' | translate" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div class="shipping-row">
            <nz-form-item>
              <nz-form-control>
                <input nz-input formControlName="phone" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_PHONE' | translate" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>

      <nz-divider></nz-divider>
      <div class="shipping-header billing-header">
        <i nz-icon nzType="bank" nzTheme="twotone" class="shipping-header-icon"></i>
        <div>
          <h3>{{ 'SIGN_ORDER.CHECKOUT.BILLING_TITLE' | translate }}</h3>
          <label
            nz-checkbox
            [ngModel]="billingSameAsShipping"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onBillingSameAsShippingChange($event)">
            {{ 'SIGN_ORDER.CHECKOUT.BILLING_SAME_AS_SHIPPING' | translate }}
          </label>
        </div>
      </div>

      <form *ngIf="!billingSameAsShipping" [formGroup]="billingForm" class="shipping-form billing-form">
        <div class="shipping-section">
          <div class="shipping-section-title"><i nz-icon nzType="bank"></i>{{ 'SIGN_ORDER.CHECKOUT.ADDRESS_COMPANY_NAME' | translate }}</div>
          <div class="shipping-row"><nz-form-item><nz-form-control [nzValidateStatus]="billingForm.get('companyName')?.touched && billingForm.get('companyName')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.REQUIRED' | translate"><input nz-input formControlName="companyName" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_COMPANY_NAME' | translate" /></nz-form-control></nz-form-item></div>
        </div>
        <div class="shipping-section">
          <div class="shipping-section-title"><i nz-icon nzType="user"></i>{{ 'SIGN_ORDER.CHECKOUT.ADDRESS_CONTACT_NAME' | translate }}</div>
          <div class="shipping-row"><nz-form-item><nz-form-control [nzValidateStatus]="billingForm.get('contactName')?.touched && billingForm.get('contactName')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.REQUIRED' | translate"><input nz-input formControlName="contactName" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_CONTACT_NAME' | translate" /></nz-form-control></nz-form-item></div>
        </div>
        <div class="shipping-section">
          <div class="shipping-section-title"><i nz-icon nzType="home"></i>{{ 'SIGN_ORDER.CHECKOUT.ADDRESS_STREET' | translate }} &amp; {{ 'SIGN_ORDER.CHECKOUT.ADDRESS_HOUSE_NUMBER' | translate }}</div>
          <div class="shipping-row street-row">
            <nz-form-item><nz-form-control [nzValidateStatus]="billingForm.get('street')?.touched && billingForm.get('street')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.REQUIRED' | translate"><input nz-input formControlName="street" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_STREET' | translate" class="street-input" /></nz-form-control></nz-form-item>
            <nz-form-item><nz-form-control [nzValidateStatus]="billingForm.get('houseNumber')?.touched && billingForm.get('houseNumber')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.REQUIRED' | translate"><input nz-input formControlName="houseNumber" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_HOUSE_NUMBER' | translate" class="number-input" /></nz-form-control></nz-form-item>
          </div>
          <div class="shipping-row"><nz-form-item><nz-form-control><input nz-input formControlName="addressLine2" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_LINE2' | translate" /></nz-form-control></nz-form-item></div>
        </div>
        <div class="shipping-section">
          <div class="shipping-section-title"><i nz-icon nzType="compass"></i>{{ 'SIGN_ORDER.CHECKOUT.ADDRESS_POSTAL_CODE' | translate }} &amp; {{ 'SIGN_ORDER.CHECKOUT.ADDRESS_CITY' | translate }}</div>
          <div class="shipping-row street-row">
            <nz-form-item><nz-form-control [nzValidateStatus]="billingForm.get('postalCode')?.touched && billingForm.get('postalCode')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.POSTAL_CODE_INVALID' | translate"><input nz-input formControlName="postalCode" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_POSTAL_CODE' | translate" class="number-input" /></nz-form-control></nz-form-item>
            <nz-form-item><nz-form-control [nzValidateStatus]="billingForm.get('city')?.touched && billingForm.get('city')?.invalid ? 'error' : ''" [nzErrorTip]="'SIGN_ORDER.CHECKOUT.REQUIRED' | translate"><input nz-input formControlName="city" [placeholder]="'SIGN_ORDER.CHECKOUT.ADDRESS_CITY' | translate" class="street-input" /></nz-form-control></nz-form-item>
          </div>
        </div>
      </form>
    </nz-card>

    <div class="draft-save-action-area">
      <ng-container *ngTemplateOutlet="draftSaveConfirmation"></ng-container>
      <div class="step-actions step-actions--with-draft">
        <button nz-button nzType="default" type="button" (click)="saveDraft()" [disabled]="!canSaveDraft" [nzLoading]="draftSaving">
          {{ 'SIGN_ORDER.DRAFTS.SAVE' | translate }}
        </button>
        <div class="step-actions__navigation">
          <button nz-button nzType="default" (click)="goToStep(STEP_DRILLING)">
            {{ 'SIGN_ORDER.CHECKOUT.BACK' | translate }}
          </button>
          <button nz-button nzType="primary" (click)="goToStep(STEP_REVIEW)">
            {{ 'SIGN_ORDER.CHECKOUT.NEXT' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #reviewStep>
  <div class="step-content">
    <nz-alert *ngIf="errorMessage" nzType="error" [nzMessage]="errorMessage" nzShowIcon class="error-alert"></nz-alert>
    <nz-alert *ngIf="priceChangedMessage" nzType="warning" [nzMessage]="priceChangedMessage" nzShowIcon class="warning-alert"></nz-alert>

    <nz-card class="review-card">
      <h3 class="review-card-title">{{ 'SIGN_ORDER.CHECKOUT.REVIEW_TITLE' | translate }}</h3>

      <nz-spin [nzSpinning]="isQuoteLoading">
        <ng-container *ngIf="quote">
          <div class="review-group">
            <div class="review-group-title">
              <i nz-icon nzType="unordered-list"></i>
              {{ 'SIGN_ORDER.CHECKOUT.ORDER_SUMMARY' | translate }}
            </div>
            <div class="review-group-body">
              <div class="review-line">
                <span>{{ 'SIGN_ORDER.CHECKOUT.UNIQUE_PROPERTIES' | translate }}</span>
                <span class="review-val">{{ quote.uniquePropertyCount }}</span>
              </div>
              <div class="review-line">
                <span>{{ 'SIGN_ORDER.CHECKOUT.TOTAL_COPIES_LABEL' | translate }}</span>
                <span class="review-val">{{ quote.totalQuantity }}</span>
              </div>
              <div class="review-line">
                <span>{{ 'SIGN_ORDER.CHECKOUT.DRILLING_OPTION' | translate }}</span>
                <span class="review-val">{{ 'SIGN_ORDER.CHECKOUT.DRILLING_' + quote.drillingOption.toUpperCase() | translate }}</span>
              </div>
              <div class="review-line">
                <span>{{ 'SIGN_ORDER.CHECKOUT.TOTAL_WEIGHT' | translate }}</span>
                <span class="review-val">{{ formatSignOrderWeight(quote.totalWeightGrams, translate.currentLang) }}</span>
              </div>
            </div>
          </div>

          <div class="review-group">
            <div class="review-group-title">
              <i nz-icon nzType="bank"></i>
              {{ 'SIGN_ORDER.CHECKOUT.BILLING_TITLE' | translate }}
            </div>
            <div class="review-group-body address-review" *ngIf="billingSameAsShipping; else separateBillingReview">
              <p>{{ 'SIGN_ORDER.CHECKOUT.BILLING_SAME_AS_SHIPPING' | translate }}</p>
            </div>
            <ng-template #separateBillingReview>
              <div class="review-group-body address-review">
                <p>{{ billingForm.get('companyName')?.value }}</p>
                <p>{{ billingForm.get('contactName')?.value }}</p>
                <p>{{ billingForm.get('street')?.value }} {{ billingForm.get('houseNumber')?.value }}</p>
                <p *ngIf="billingForm.get('addressLine2')?.value">{{ billingForm.get('addressLine2')?.value }}</p>
                <p>{{ billingForm.get('postalCode')?.value }} {{ billingForm.get('city')?.value }}, {{ translate.currentLang === 'de' ? 'Deutschland' : 'Germany' }}</p>
              </div>
            </ng-template>
          </div>

          <div class="review-group" *ngIf="cachedSelectedList.length">
            <div class="review-group-title">
              <i nz-icon nzType="home"></i>
              {{ 'SIGN_ORDER.CHECKOUT.SELECTED_PROPERTIES' | translate }} ({{ cachedSelectedList.length }})
            </div>
            <div class="review-group-body">
              <div class="review-line" *ngFor="let prop of cachedSelectedList">
                <span>{{ prop.address }}</span>
                <span class="review-val">{{ getPropertyCopies(prop.id) }}</span>
              </div>
            </div>
          </div>

          <div class="review-group">
            <div class="review-group-title">
              <i nz-icon nzType="dollar"></i>
              {{ 'SIGN_ORDER.CHECKOUT.PRICE_BREAKDOWN' | translate }}
            </div>
            <div class="review-group-body">
              <div class="review-line">
                <span>{{ (quote.drillingOption === 'with_drilling' ? 'SIGN_ORDER.CHECKOUT.UNIT_PRICE_INCL_DRILLING' : 'SIGN_ORDER.CHECKOUT.UNIT_PRICE') | translate }}</span>
                <span class="review-val">{{ formatCents(quote.combinedUnitNetCents, quote.currency) }}</span>
              </div>
              <div class="review-line">
                <span>{{ 'SIGN_ORDER.CHECKOUT.SIGNS_SUBTOTAL' | translate }}</span>
                <span class="review-val">{{ formatCents(quote.signsNetSubtotalCents, quote.currency) }}</span>
              </div>
              <div class="review-line">
                <span>{{ 'SIGN_ORDER.CHECKOUT.SHIPPING' | translate }}</span>
                <span class="review-val">{{ formatCents(quote.shippingNetCents, quote.currency) }}</span>
              </div>
              <div class="review-line review-line-divider"></div>
              <div class="review-line">
                <span>{{ 'SIGN_ORDER.CHECKOUT.TAXABLE_NET' | translate }}</span>
                <span class="review-val">{{ formatCents(quote.taxableNetCents, quote.currency) }}</span>
              </div>
              <div class="review-line">
                <span>{{ 'SIGN_ORDER.CHECKOUT.VAT' | translate }} ({{ formatVatRate(quote.vatRateBasisPoints) }})</span>
                <span class="review-val">{{ formatCents(quote.vatAmountCents, quote.currency) }}</span>
              </div>
              <div class="review-line review-line-total">
                <span>{{ 'SIGN_ORDER.CHECKOUT.GROSS_TOTAL' | translate }}</span>
                <span class="review-val">{{ formatCents(quote.grossTotalCents, quote.currency) }}</span>
              </div>
            </div>
          </div>

          <div class="review-group">
            <div class="review-group-title">
              <i nz-icon nzType="environment"></i>
              {{ 'SIGN_ORDER.CHECKOUT.SHIPPING_ADDRESS' | translate }}
            </div>
            <div class="review-group-body address-review">
              <p>{{ shippingForm.get('companyName')?.value }}</p>
              <p>{{ shippingForm.get('contactName')?.value }}</p>
              <p>{{ shippingForm.get('street')?.value }} {{ shippingForm.get('houseNumber')?.value }}</p>
              <p *ngIf="shippingForm.get('addressLine2')?.value">{{ shippingForm.get('addressLine2')?.value }}</p>
              <p>{{ shippingForm.get('postalCode')?.value }} {{ shippingForm.get('city')?.value }}, Deutschland</p>
              <p>{{ shippingForm.get('email')?.value }}</p>
              <p *ngIf="shippingForm.get('phone')?.value">{{ shippingForm.get('phone')?.value }}</p>
            </div>
          </div>
        </ng-container>

        <div class="review-group" *ngIf="quote && (posterPreviewResponse || posterPreviewLoading || posterPreviewUnavailable)">
          <div class="review-group-title">
            <i nz-icon nzType="picture"></i>
            {{ 'SIGN_ORDER.CHECKOUT.POSTER_PREVIEW' | translate }}
          </div>
          <div class="review-group-body poster-preview-body">

            <ng-container *ngIf="posterPreviewResponse">
            <div class="poster-template-label">
              <ng-container *ngIf="posterPreviewResponse.templateSource === 'custom'; else defaultLabel">
                {{ posterPreviewResponse.templateDisplayName ? ('SIGN_ORDER.CHECKOUT.POSTER_ACTIVE_TEMPLATE' | translate:{ name: posterPreviewResponse.templateDisplayName }) : ('SIGN_ORDER.CHECKOUT.POSTER_CUSTOM_FALLBACK' | translate) }}
              </ng-container>
              <ng-template #defaultLabel>
                {{ 'SIGN_ORDER.CHECKOUT.POSTER_DEFAULT' | translate }}
              </ng-template>
            </div>
            <p class="poster-default-notice" *ngIf="posterPreviewResponse.templateSource === 'default'">
              {{ 'SIGN_ORDER.CHECKOUT.POSTER_DEFAULT_NOTICE' | translate }}
            </p>

            <div class="poster-property-info">
              <span *ngIf="posterPreviewResponse.properties.length > 0">
                <strong>{{ getSelectedPreviewProperty()?.propertyAddress || '' }}</strong>
                &nbsp;&middot;&nbsp;
                {{ 'SIGN_ORDER.CHECKOUT.POSTER_COPIES' | translate:{ count: getSelectedPreviewProperty()?.copies || 0 } }}
              </span>
            </div>

            <div class="poster-property-selector" *ngIf="posterPreviewResponse.properties.length > 1">
              <nz-select
                [ngModel]="posterPreviewSelectedPropertyId"
                (ngModelChange)="posterPreviewSelectedPropertyId = $event; onPosterPropertyChange()"
                nzSize="small"
                nzShowSearch
                [nzDisabled]="posterPreviewLoading || !posterPreviewAssetsReady || posterPreviewUnavailable"
                style="width:100%">
                <nz-option
                  *ngFor="let p of posterPreviewResponse.properties"
                  [nzValue]="p.propertyId"
                  [nzLabel]="p.propertyAddress + ' \u00B7 ' + p.copies"
                ></nz-option>
              </nz-select>
            </div>

          <div class="poster-preview-frame" *ngIf="posterPreviewLoading || posterPreviewReady">
            <canvas
              #posterPreviewCanvas
              class="poster-preview-canvas"
              [class.poster-preview-canvas--hidden]="!posterPreviewReady"
              role="img"
              [attr.aria-label]="'SIGN_ORDER.CHECKOUT.POSTER_PREVIEW' | translate"
            ></canvas>
            <canvas
              #posterPreviewRenderCanvas
              class="poster-preview-render-canvas"
              aria-hidden="true"
            ></canvas>
            <div class="poster-preview-loading-overlay" *ngIf="posterPreviewLoading">
              <nz-spin nzSimple></nz-spin>
              <p>{{ 'SIGN_ORDER.CHECKOUT.POSTER_LOADING' | translate }}</p>
            </div>
          </div>

            </ng-container>

            <div class="poster-preview-loading" *ngIf="posterPreviewLoading && !posterPreviewReady && !posterPreviewResponse">
              <nz-spin nzSimple></nz-spin>
              <p>{{ 'SIGN_ORDER.CHECKOUT.POSTER_LOADING' | translate }}</p>
            </div>

            <div class="poster-preview-error" *ngIf="posterPreviewUnavailable">
              <i nz-icon nzType="exclamation-circle"></i>
              <p>{{ 'SIGN_ORDER.CHECKOUT.POSTER_ERROR' | translate }}</p>
            </div>

            <p class="poster-immutable-notice" *ngIf="posterPreviewReady && !posterPreviewLoading">
              <i nz-icon nzType="lock"></i>
              {{ 'SIGN_ORDER.CHECKOUT.POSTER_IMMUTABLE' | translate }}
            </p>
          </div>
        </div>

        <div *ngIf="!quote && cachedItemCount === 0" class="empty-state">
          <p>{{ 'SIGN_ORDER.CHECKOUT.NO_SELECTION' | translate }}</p>
        </div>

        <div class="review-notices" *ngIf="quote">
          <div class="review-notice-item">
            <i nz-icon nzType="info-circle"></i>
            <span>{{ 'SIGN_ORDER.LEGAL.CUSTOM_PRODUCTION' | translate }}</span>
          </div>
          <div class="review-notice-item">
            <i nz-icon nzType="tool"></i>
            <span>{{ 'SIGN_ORDER.LEGAL.INSTALLATION_NOTICE' | translate }}</span>
          </div>
          <div class="review-notice-item privacy-link">
            <i nz-icon nzType="lock"></i>
            <span>{{ 'SIGN_ORDER.LEGAL.PRIVACY_INFO' | translate }}</span>
            <a *ngIf="legalLinks.length" [href]="legalLinks[2]?.url" target="_blank" rel="noopener noreferrer">{{ 'SIGN_ORDER.LEGAL.LINK_PRIVACY' | translate }}</a>
          </div>
        </div>
      </nz-spin>
    </nz-card>

    <div class="legal-confirmations" *ngIf="quote">
      <nz-alert *ngIf="legalUnavailable" nzType="warning" [nzMessage]="'SIGN_ORDER.LEGAL.LEGAL_UNAVAILABLE' | translate" nzShowIcon class="legal-error"></nz-alert>
      <ng-container *ngIf="!legalUnavailable && legalLinks.length === 4">
      <div class="legal-notices">
        <p class="legal-disclosure-text">{{ 'SIGN_ORDER.LEGAL.PRODUCTION_NOTICE' | translate }}</p>
        <p class="legal-disclosure-text">{{ 'SIGN_ORDER.LEGAL.SNAPSHOT_NOTICE' | translate }}</p>
      </div>
      <label nz-checkbox [(ngModel)]="confirmBusiness" class="legal-check">
        {{ 'SIGN_ORDER.LEGAL.CONFIRM_BUSINESS' | translate }}
      </label>
      <label nz-checkbox [(ngModel)]="confirmContent" class="legal-check">
        {{ 'SIGN_ORDER.LEGAL.CONFIRM_CONTENT' | translate }}
      </label>
      <label nz-checkbox [(ngModel)]="confirmSnapshot" [nzDisabled]="!posterPreviewRevision || !posterPreviewReady || posterPreviewLoading || posterPreviewUnavailable || !posterPreviewAssetsReady" class="legal-check">
        {{ 'SIGN_ORDER.LEGAL.CONFIRM_SNAPSHOT' | translate }}
      </label>
      <label nz-checkbox [(ngModel)]="confirmTerms" class="legal-check">
        {{ 'SIGN_ORDER.LEGAL.CONFIRM_TERMS' | translate }}
      </label>
      <div class="legal-links">
        <a *ngFor="let link of legalLinks" [href]="link.url" target="_blank" rel="noopener noreferrer" class="legal-link">{{ link.label | translate }}</a>
      </div>
      </ng-container>
    </div>

    <div class="draft-save-action-area">
      <ng-container *ngTemplateOutlet="draftSaveConfirmation"></ng-container>
      <div class="step-actions step-actions--with-draft">
        <button nz-button nzType="default" type="button" (click)="saveDraft()" [disabled]="!canSaveDraft" [nzLoading]="draftSaving">
          {{ 'SIGN_ORDER.DRAFTS.SAVE' | translate }}
        </button>
        <div class="step-actions__navigation">
          <button nz-button nzType="default" (click)="goToStep(STEP_SHIPPING)">
            {{ 'SIGN_ORDER.CHECKOUT.BACK' | translate }}
          </button>
          <button nz-button nzType="primary"
            (click)="submitOrder()"
            [disabled]="isSubmitting || quoteIsStale || !quote || !shippingForm.valid || !isBillingAddressValid() || !confirmBusiness || !confirmContent || !confirmSnapshot || !confirmTerms || legalUnavailable || legalLinks.length !== 4 || posterPreviewLoading || posterPreviewUnavailable || !posterPreviewRevision || !posterPreviewReady || !posterPreviewAssetsReady"
            [nzLoading]="isSubmitting">
            {{ 'SIGN_ORDER.CHECKOUT.SUBMIT_LEGAL' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #confirmationStep>
  <div class="step-content" *ngIf="createdOrder">
    <div class="confirm-card">
      <div class="confirm-hero">
        <i nz-icon nzType="check-circle" nzTheme="twotone" [nzTwotoneColor]="'#52c41a'" class="confirm-hero-icon"></i>
        <h2>{{ 'SIGN_ORDER.CHECKOUT.CONFIRMATION_TITLE' | translate }}</h2>
        <p class="confirm-subtitle">{{ 'SIGN_ORDER.CHECKOUT.CONFIRMATION_MSG' | translate:{ orderNumber: createdOrder.orderNumber } }}</p>
      </div>

      <div class="confirm-group">
        <div class="confirm-group-title">
          <i nz-icon nzType="unordered-list"></i>
          {{ 'SIGN_ORDER.CHECKOUT.ORDER_SUMMARY' | translate }}
        </div>
        <div class="confirm-group-body">
          <div class="review-line">
            <span>{{ 'SIGN_ORDER.CHECKOUT.ORDER_NUMBER' | translate }}</span>
            <span class="review-val"><strong>{{ createdOrder.orderNumber }}</strong></span>
          </div>
          <div class="review-line">
            <span>{{ 'SIGN_ORDER.CHECKOUT.TOTAL_COPIES_LABEL' | translate }}</span>
            <span class="review-val">{{ createdOrder.totalCopies }}</span>
          </div>
          <div class="review-line">
            <span>{{ 'SIGN_ORDER.CHECKOUT.DRILLING_OPTION' | translate }}</span>
            <span class="review-val">{{ 'SIGN_ORDER.CHECKOUT.DRILLING_' + createdOrder.drillingOption.toUpperCase() | translate }}</span>
          </div>
          <div class="review-line">
            <span>{{ 'SIGN_ORDER.CHECKOUT.TOTAL_WEIGHT' | translate }}</span>
            <span class="review-val">{{ formatSignOrderWeight(createdOrder.pricing.totalWeightGrams, translate.currentLang) }}</span>
          </div>
          <div class="review-line">
            <span>{{ (createdOrder.drillingOption === 'with_drilling' ? 'SIGN_ORDER.CHECKOUT.UNIT_PRICE_INCL_DRILLING' : 'SIGN_ORDER.CHECKOUT.UNIT_PRICE') | translate }}</span>
            <span class="review-val">{{ formatCents(createdOrder.pricing.combinedUnitNetCents, createdOrder.currency) }}</span>
          </div>
          <div class="review-line">
            <span>{{ 'SIGN_ORDER.CHECKOUT.SIGNS_SUBTOTAL' | translate }}</span>
            <span class="review-val">{{ formatCents(createdOrder.pricing.signsNetSubtotalCents, createdOrder.currency) }}</span>
          </div>
          <div class="review-line">
            <span>{{ 'SIGN_ORDER.CHECKOUT.SHIPPING' | translate }}</span>
            <span class="review-val">{{ formatCents(createdOrder.pricing.shippingNetCents, createdOrder.currency) }}</span>
          </div>
          <div class="review-line">
            <span>{{ 'SIGN_ORDER.CHECKOUT.VAT' | translate }} ({{ formatVatRate(createdOrder.pricing.vatRateBasisPoints) }})</span>
            <span class="review-val">{{ formatCents(createdOrder.pricing.vatAmountCents, createdOrder.currency) }}</span>
          </div>
          <div class="review-line review-line-total">
            <span>{{ 'SIGN_ORDER.CHECKOUT.GROSS_TOTAL' | translate }}</span>
            <span class="review-val">{{ formatCents(createdOrder.grossTotalCents, createdOrder.currency) }}</span>
          </div>
          <div class="review-line">
            <span>{{ 'SIGN_ORDER.CHECKOUT.PAYMENT_REFERENCE' | translate }}</span>
            <span class="review-val"><code>{{ createdOrder.paymentReference }}</code></span>
          </div>
        </div>
      </div>

      <div class="confirm-group">
        <div class="confirm-group-title">
          <i nz-icon nzType="credit-card"></i>
          {{ 'SIGN_ORDER.CHECKOUT.PAYMENT_INSTRUCTIONS' | translate }}
        </div>
        <div class="confirm-group-body payment-instructions-body">
          <p>{{ localizedPaymentInstructions(createdOrder.paymentInstructions?.instructions) }}</p>
        </div>
      </div>

      <div class="confirm-notice">
        <i nz-icon nzType="info-circle"></i>
        {{ 'SIGN_ORDER.CHECKOUT.PROCESSING_NOTE' | translate }}
      </div>

      <div class="confirm-group" *ngIf="createdOrder.legalAcceptanceSnapshot">
        <div class="confirm-group-title">
          <i nz-icon nzType="safety"></i>
          {{ 'SIGN_ORDER.LEGAL.LEGAL_ACCEPTANCE' | translate }}
        </div>
        <div class="confirm-group-body">
          <p style="font-size:13px;color:#6b7280">{{ 'SIGN_ORDER.LEGAL.LEGAL_CONFIRMED' | translate:{ date: formatSignOrderDateTime(createdOrder.legalAcceptanceSnapshot?.acceptedAt, translate.currentLang) } }}</p>
        </div>
      </div>

      <div class="step-actions">
        <button nz-button nzType="primary" nzSize="large" (click)="navigateOrder.emit(createdOrder.publicId)" class="confirm-btn">
          {{ 'SIGN_ORDER.CHECKOUT.VIEW_ORDER' | translate }}
        </button>
        <button nz-button nzType="default" nzSize="large" (click)="navigateOrders.emit()">
          {{ 'SIGN_ORDER.CHECKOUT.VIEW_ORDERS' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
